import React from 'react';


export const MED_BENEFITS = [
  'Medical Evacuation & Transport',
  'Home Hospital Repatriation',
  'Escort & Companion Assistance',
  'Dependent Children Assistance',
  'CAP Advantage App',
  'Translation and Interpretation',
  'Emergency Message Relay',
  'Return of Vehicle',
  'Legal Referrals',
  'Repatriation of Mortal Remains'
  
  
];

export const COMPLETE_ONLY_BENEFITS = [
  'Natural Disaster Response',
  'Political Threat Assistance',
  'Terrorism Crisis Support',
  'Wrongful Detention Support',
  'Emergency Relocation',
  'Crisis Consultation',
  'Kidnap & Ransom Response',
  'Riots & Civil Commotion Evacuation'
];

export const COMPARE_ROWS = []
  .concat(MED_BENEFITS.map(function (l) { return { label: l, med: true, comp: true }; }))
  .concat(COMPLETE_ONLY_BENEFITS.map(function (l) { return { label: l, med: false, comp: true }; }));

export const PAYMENT_METHODS = [
  { key: 'card',   label: 'Credit/Debit Card & Wallets' },
  { key: 'paypal', label: 'PayPal' }
];

export function ArrowLeftIcon() {
  return (
    <svg width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M15 18l-6-6 6-6' />
    </svg>
  );
}

export function StoreBadgeIcon() {
  return (
    <svg width='22' height='22' viewBox='0 0 24 24' fill='currentColor'>
      <path d='M12 2L2 22h20L12 2z' />
    </svg>
  );
}

export function ChevronDownIcon() {
  return (
    <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.4' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M6 9l6 6 6-6' />
    </svg>
  );
}

export function PinIcon(props) {
  const size = (props && props.size) || 15;
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0116 0z' />
      <circle cx='12' cy='10' r='3' />
    </svg>
  );
}

export function CheckIcon(props) {
  const size = (props && props.size) || 11;
  const color = (props && props.color) || 'currentColor';
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke={color} strokeWidth='3' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M20 6L9 17l-5-5' />
    </svg>
  );
}

export function HelpIcon() {
  return (
    <svg width='17' height='17' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
      <circle cx='12' cy='12' r='9' />
      <path d='M9.5 9a2.5 2.5 0 015 .2c0 1.7-2.5 2-2.5 3.8M12 17h.01' />
    </svg>
  );
}

export function ShieldIcon(props) {
  const color = (props && props.color) || 'currentColor';
  return (
    <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke={color} strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z' />
    </svg>
  );
}

export function MedicalPlanIcon(props) {
  const size = (props && props.size) || 23;
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinejoin='round' strokeLinecap='round'>
      <rect x='3' y='7' width='18' height='13' rx='2.5' />
      <path d='M8 7V5.5A2 2 0 0110 3.5h4a2 2 0 012 2V7' />
      <path d='M12 11v5M9.5 13.5h5' />
    </svg>
  );
}

export function WarningIcon() {
  return (
    <svg width='17' height='17' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M12 9v4M12 17h.01M10.3 3.9L2 18a2 2 0 001.7 3h16.6a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0z' />
    </svg>
  );
}

export function CompletePlanIcon() {
  return (
    <svg width='25' height='25' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinejoin='round' strokeLinecap='round'>
      <path d='M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z' />
      <path d='M8.8 11.8l2.2 2.2 4.2-4.4' />
    </svg>
  );
}

export function UpArrowIcon() {
  return (
    <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.4' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M12 19V5M5 12l7-7 7 7' />
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M18 6L6 18M6 6l12 12' />
    </svg>
  );
}

export function HomeIcon() {
  return (
    <svg width='21' height='21' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M3 11l9-8 9 8M5 10v10h14V10' />
    </svg>
  );
}

export function InfoIcon() {
  return (
    <svg width='17' height='17' viewBox='0 0 24 24' fill='none' stroke='#2E74B8' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M12 16v-4M12 8h.01' />
      <circle cx='12' cy='12' r='9' />
    </svg>
  );
}

export function LockIcon() {
  return (
    <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='#56B947' strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round'>
      <rect x='4' y='11' width='16' height='10' rx='2' />
      <path d='M8 11V7a4 4 0 018 0v4' />
    </svg>
  );
}

export function ArrowRightIcon() {
  return (
    <svg className='cap-pay-alt__icon' width='17' height='17' viewBox='0 0 24 24' fill='none' stroke='#2E74B8' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M5 12h14M13 6l6 6-6 6' />
    </svg>
  );
}

export function SidebarPlanIcon(props) {
  const plan = props && props.plan;
  return (
    <svg width='21' height='21' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinejoin='round' strokeLinecap='round'>
      {plan === 'complete' ? (
        <path d='M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z' />
      ) : (
        <rect x='3' y='7' width='18' height='13' rx='2.5' />
      )}
    </svg>
  );
}

export function SpinnerIcon(props) {
  const size = props.size || 25;
  const color = props.color || 'currentColor';
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2.5" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      style={{ animation: 'cap-spin 1s linear infinite' }}
    >
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      <style>{`
        @keyframes cap-spin {
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </svg>
  );
}